import SelectCheckbox from './SelectCheckbox';

export default SelectCheckbox;
